import gql from "graphql-tag"

const fragment = gql`
  fragment fullTag on Tag {
    filterable
    name
    url
    uuid
    kind
    image
    locale
    childrenIds
    children @include(if: $withChildren) {
      filterable
      name
      url
      uuid
      kind
      image
      locale
      childrenIds
    }
  }
`

export default fragment
